import { useEffect, useState } from "react";

export const Counter = ({ value = 0, cap = 100000 }) => {
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (value <= 0) {
      setDisplay(0);
      return;
    }
    const start = Math.max(0, value - 40);
    let current = start;
    setDisplay(start);
    const step = Math.max(1, Math.round((value - start) / 30));
    const id = setInterval(() => {
      current += step;
      if (current >= value) {
        current = value;
        clearInterval(id);
      }
      setDisplay(current);
    }, 40);
    return () => clearInterval(id);
  }, [value]);

  const padded = String(display).padStart(6, "0");

  return (
    <div data-testid="promesse-counter" className="flex flex-col items-center gap-2">
      <p className="font-mono text-2xl md:text-3xl tracking-[0.3em] text-museo-accent">
        {padded} / {cap.toLocaleString("it-IT")}
      </p>
      <p className="text-xs uppercase tracking-[0.3em] text-museo-muted">posti occupati</p>
    </div>
  );
};
